const clabeFormatter = (clabe) =>
  clabe ? clabe.replace(/(\d{3})(\d{3})(\d{11})(\d)/, "$1 $2 $3 $4") : "";

export default clabeFormatter;
